<template>
	<div class="home" :class="`${theme}-theme`">
		<PanelView v-if="isAuthorized" :theme="theme" :size="size" />
	</div>
</template>

<script>
import { computed, onMounted, ref } from 'vue';
import { useStore } from '@/store';
import VueJwtDecode from 'vue-jwt-decode';
import PanelView from './panels/PanelView';

export default {
	name: 'PanelPage',
	components: {
		PanelView,
	},
	props: {
		isMobile: {
			type: Boolean,
			default: false,
		},
		isComponentView: {
			type: Boolean,
			default: false,
		},
	},
	setup(props) {
		const store = useStore();

		const theme = computed(() => store.state.theme);
		const size = computed(() => store.state.size);

		store.commit('setIsMobile', props.isMobile);
		store.commit('setIsComponentView', props.isComponentView);

		// Set size for component view.
		if (props.isComponentView) {
			store.commit('setSize', 'md');
		}

		// Load extension version.
		onMounted(() => {
			const path = window.location.pathname.split('/');
			if (path.length > 2) {
				store.commit('setExtensionVersion', path[2]);
			}
		});

		const isAuthorized = ref(false);
		window.Twitch.ext.onAuthorized(function (auth) {
			store.commit('setTwitchAuth', auth);
			isAuthorized.value = true;

			const claims = VueJwtDecode.decode(auth.token);
			//console.log(JSON.stringify(claims, null, 4));

			// See https://dev.twitch.tv/docs/extensions/#identity for identity details.
			store.commit('setTwitchAuthToken', auth.token);
			store.commit('setUserId', claims.user_id);
			store.commit('setOpaqueUserId', claims.opaque_user_id);
			store.commit('setChannelId', claims.channel_id);

			if (claims.user_id) {
				store.commit('setRole', claims.channel_id != claims.user_id ? 'viewer' : 'broadcaster');
			} else {
				store.commit('setRole', 'viewer');
			}

			// Set viewer subscription status.
			const viewer = window.Twitch.ext.viewer;
			if (viewer.subscriptionStatus) {
				store.commit('setSubscriber', true);
			} else {
				store.commit('setSubscriber', false);
			}
		});

		window.Twitch.ext.onError(function (error) {
			console.error(error);
		});

		// Listen for party mode on / off.
		window.Twitch.ext.listen('broadcast', (target, contentType, message) => {
			console.log(
				`Broadcast message received, target is ${target}, contentType is ${contentType}, message is ${message}`,
			);
			if (message) {
				if (message == 'partyModeOn') {
					store.commit('setIsPartyModeOn', true);
				} else if (message == 'partyModeOff') {
					store.commit('setIsPartyModeOn', false);
				}
			}
		});

		return {
			isAuthorized,
			theme,
			size,
		};
	},
};
</script>
